import { addDays, differenceInCalendarDays } from "date-fns";

// En France, la grossesse se compte en semaines d'aménorrhée (SA) depuis le 1er
// jour des dernières règles. La conception a lieu environ 14 jours plus tard,
// d'où les semaines de grossesse (SG) = SA − 2. Le terme est fixé à 41 SA.
export const CONCEPTION_OFFSET_DAYS = 14;
export const TERM_DAYS = 41 * 7;
export const FULL_TERM_SA = 37;

// Ramène n'importe quelle base de calcul à la date des dernières règles.
export function lastPeriodFrom(option, date) {
  if (option === "startPregnancy") return addDays(date, -CONCEPTION_OFFSET_DAYS);
  if (option === "endPregnancy") return addDays(date, -TERM_DAYS);
  return date;
}

// Mois entamé depuis la conception, en mois civils : 9 mois de la conception au
// terme, comme on les compte couramment.
function pregnancyMonth(conception, ref) {
  let months = (ref.getFullYear() - conception.getFullYear()) * 12 + (ref.getMonth() - conception.getMonth());
  if (ref.getDate() < conception.getDate()) months -= 1;
  return Math.min(9, Math.max(1, months + 1));
}

// Trimestres en SA révolues : jusqu'à 14 SA, de 15 à 28 SA, puis à partir de 29 SA.
export function trimesterFor(sa) {
  if (sa <= 14) return 1;
  if (sa <= 28) return 2;
  return 3;
}

export function pregnancyAt(lastPeriod, ref) {
  const days = differenceInCalendarDays(ref, lastPeriod);
  const conception = addDays(lastPeriod, CONCEPTION_OFFSET_DAYS);
  const dueDate = addDays(lastPeriod, TERM_DAYS);

  if (days < 0) return { status: "notStarted", lastPeriod, conception, dueDate };

  const sgDays = days - CONCEPTION_OFFSET_DAYS;
  const sa = Math.floor(days / 7);

  return {
    status: days > TERM_DAYS ? "overdue" : sa >= FULL_TERM_SA ? "fullTerm" : "ongoing",
    lastPeriod,
    conception,
    dueDate,
    days,
    sa,
    saDays: days % 7,
    // Avant la conception supposée, il n'y a pas encore de semaine de grossesse.
    sg: sgDays >= 0 ? Math.floor(sgDays / 7) : null,
    sgDays: sgDays >= 0 ? sgDays % 7 : null,
    month: pregnancyMonth(conception, ref),
    trimester: trimesterFor(sa),
    daysToTerm: differenceInCalendarDays(dueDate, ref),
    progress: Math.min(100, Math.round((days / TERM_DAYS) * 100)),
  };
}

// Mirrors the min/max on the date inputs: a typed year outside this range would
// otherwise produce results like "5 000 SA".
export function isPlausible(date) {
  if (!(date instanceof Date) || isNaN(date.getTime())) return false;
  const y = date.getFullYear();
  return y >= 2000 && y <= 2035;
}
